import { AppEnvironment } from './environment.model';

export const environment: AppEnvironment = {
  production: false,
  apiBaseUrl: 'https://dsdn-backend-dev.politeforest-53158118.canadacentral.azurecontainerapps.io',
  microsoftAuth: {
    clientId: 'f5055f7d-e921-42aa-a09d-d92825a8fbea',
    authority: 'https://login.microsoftonline.com/d6e9243e-6c0a-4a12-935f-a909d07b5099',
    redirectPath: '/login',
    redirectUri: 'https://dev.dsdn.ca/login',
    loginScopes: ['openid', 'profile', 'email'],
    allowedEmailDomains: ['desimone.com']
  }
};
